var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVectorDownBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41 0.619019L6 5.18488L10.59 0.619019L12 2.03155L6 7.99999L0 2.03155L1.41 0.619019Z",
    fill: "#2979FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorDownBlue);
export default __webpack_public_path__ + "static/media/VectorDownBlue.a76350b08f34e8f69fcd08f1030bb710.svg";
export { ForwardRef as ReactComponent };